import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function Community() {
    return <WebPage title="QENDO communities" uri={QENDO_LINKS.community} />;
}
